import React from "react";

import DatePickerCustomInput from "../DatePickerCustomInput";
import * as S from "./styles";

export default function BorderedDatePicker({
  disabled,
  label,
  selected,
  setSelected,
}) {
  return (
    <S.Wrapper>
      <S.Main>
        <S.Label>{label}</S.Label>
        <S.DatePickerCustom
          dateFormat="dd/MM/yyyy"
          disabled={disabled}
          selected={selected}
          onChange={setSelected}
          customInput={<DatePickerCustomInput />}
        />
      </S.Main>
    </S.Wrapper>
  );
}
